import styled from 'foundations-theming/utils';
import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UICheckbox from 'UIComponents/input/UICheckbox';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DisabledStyleDiv = styled.div.withConfig({
  displayName: "EnrollExistingFromTriggers__DisabledStyleDiv",
  componentId: "sc-10etukp-0"
})(["color:rgba(51,71,91,0.5);"]);
const StyledHeaderContainer = styled.div.withConfig({
  displayName: "EnrollExistingFromTriggers__StyledHeaderContainer",
  componentId: "sc-10etukp-1"
})(["color:", ";"], ({
  theme
}) => theme.color['do-not-use-obsidian']);
const EnrollExistingFromTriggers = ({
  flow,
  filtersFromCurrentTriggers,
  useRefinementFilters,
  setUseRefinementFilters,
  mode
}) => {
  const refinementList = flow.associatedLists ? flow.associatedLists.find(list => list.listTypes.includes('REFINE_BY_LIST')) : undefined;
  const filterHeader = /*#__PURE__*/_jsx(H5, {
    className: "m-bottom-4",
    children: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.filterHeader_cob",
        objectTypeId: flow.objectTypeId
      })
    })
  });
  const refinementFilterHeader = /*#__PURE__*/_jsx(StyledHeaderContainer, {
    children: /*#__PURE__*/_jsx(H5, {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.refinementHeader"
        })
      })
    })
  });
  return /*#__PURE__*/_jsx(UIPanelSection, {
    className: "m-top-10 p-top-0",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.title"
        })
      }), mode === 'EXISTING' ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.informationExisting_cob",
        objectTypeId: flow.objectTypeId
      }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.information_cob",
        objectTypeId: flow.objectTypeId
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "600",
        as: "div",
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "800",
          as: "div",
          children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
            headerNode: filterHeader,
            objectTypeId: flow.objectTypeId,
            value: filtersFromCurrentTriggers.filterBranch,
            readOnly: true
          })
        }), !useRefinementFilters && refinementList && /*#__PURE__*/_jsx(DisabledStyleDiv, {
          className: "m-right-8",
          children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
            headerNode: refinementFilterHeader,
            objectTypeId: flow.objectTypeId,
            value: refinementList && refinementList.filterBranch,
            readOnly: true
          })
        }), refinementList && /*#__PURE__*/_jsx(UICheckbox, {
          className: "m-top-4",
          checked: useRefinementFilters,
          onChange: () => {
            setUseRefinementFilters(!useRefinementFilters);
          },
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.selected.refinementSelect_cob",
            objectTypeId: flow.objectTypeId
          })
        })]
      })]
    })
  });
};
export default EnrollExistingFromTriggers;